import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from '@/components/Sidebar'
import { Header } from '@/components/Header'

export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-slate-50 text-slate-900 font-sans antialiased">
      {/* Sticky Sidebar Container */}
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main Content Viewport with independent scroll */}
      <div className="flex min-w-0 flex-1 flex-col h-screen overflow-hidden bg-slate-50">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto overflow-x-hidden bg-slate-50 px-4 py-5 lg:px-7 lg:py-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
